import { ENVIRONMENT, IS_AU_INSTANCE } from "utils/environmentVariables";
import { ALL_ALLIANZ_COACHBOT_PROMPT_TEMPLATES } from "./CompanySpecificPrompts/constants";
import { ALL_COACHBOT_PROMPT_TEMPLATES } from "./constants";
import { NA_IMPORTANT_COMPANY_ACCOUNTS } from "../AdminConsole/constants";
import { AppDispatch } from "utils/redux/store";
import {
  resetChatbotState,
  setChatbotFullScreen,
  setCoachBotPrompt,
  setIsCoachbotOpen,
} from "../Chatbot/slice";
import { CoachbotCardTemplate, CoachBoTemplateSection } from "./types";

const getIsAllianzCompany = (companyAccountId?: number) => {
  // This is for testing purposes on dev.
  if (ENVIRONMENT === "dev" && companyAccountId === 284945) {
    return true;
  }

  return (
    !IS_AU_INSTANCE &&
    companyAccountId === NA_IMPORTANT_COMPANY_ACCOUNTS.Allianz
  );
};

export const getCoachBoPromptNavs = (companyAccountId?: number) => {
  const arr = Object.keys(ALL_COACHBOT_PROMPT_TEMPLATES).map((key) => ({
    title: key,
  }));

  if (getIsAllianzCompany(companyAccountId)) {
    Object.keys(ALL_ALLIANZ_COACHBOT_PROMPT_TEMPLATES).forEach((key) => {
      arr.push({
        title: key,
      });
    });
  }
  return arr;
};

export const getCardTemplate = (
  navSelected: string | null,
  companyAccountId?: number
) => {
  let TEMPLATES = ALL_COACHBOT_PROMPT_TEMPLATES;

  if (getIsAllianzCompany(companyAccountId)) {
    TEMPLATES = {
      ...TEMPLATES,
      ...(ALL_ALLIANZ_COACHBOT_PROMPT_TEMPLATES as unknown as CoachBoTemplateSection),
    };
  }
  return TEMPLATES[navSelected ?? ""]?.promptTemplates ?? [];
};

export const getAllAvailableCoachBoPromptTemplates = (
  companyAccountId?: number
) => {
  let TEMPLATES = ALL_COACHBOT_PROMPT_TEMPLATES;

  if (getIsAllianzCompany(companyAccountId)) {
    TEMPLATES = {
      ...TEMPLATES,
      ...(ALL_ALLIANZ_COACHBOT_PROMPT_TEMPLATES as unknown as CoachBoTemplateSection),
    };
  }
  return TEMPLATES;
};

export const setAllianzGrowthMindsetCoachBoChat = (
  dispatch: AppDispatch,
  companyAccountId?: number
) => {
  const template = getTemplatePromptFromType(
    "allianzGrowthMindsetChat",
    companyAccountId
  );
  if (!template) return;

  dispatch(resetChatbotState());
  dispatch(
    setCoachBotPrompt({
      userPrompts: template.preSelectedPrompts ?? [],
      coachBotIntro: template.coachBotIntro,
      chatType: template.chatType ?? "",
    })
  );
  dispatch(setIsCoachbotOpen(true));
  dispatch(setChatbotFullScreen(true));
};

export const getTemplatePromptFromType = (
  type: string,
  companyAccountId?: number
): null | CoachbotCardTemplate => {
  if (getIsAllianzCompany(companyAccountId)) {
    const foundTemplate = findTemplateFromType(
      type,
      ALL_ALLIANZ_COACHBOT_PROMPT_TEMPLATES as unknown as CoachBoTemplateSection
    );
    if (foundTemplate) {
      return foundTemplate;
    }
  }

  return findTemplateFromType(
    type,
    ALL_COACHBOT_PROMPT_TEMPLATES as unknown as CoachBoTemplateSection
  );
};

const findTemplateFromType = (
  type: string,
  PROMPTS: CoachBoTemplateSection
) => {
  for (const value of Object.values(PROMPTS)) {
    const template = value.promptTemplates.find((t) => t.chatType === type);
    if (template) {
      return template;
    }
  }
  return null;
};
